import { Injectable } from "@angular/core"
import { map } from "rxjs/operators"
import { environment } from "../../../../environments/environment"
import { Brand } from "../models/brand/brand"
import { AppService } from "../../../core/services/app.service"
import { HttpClient, HttpParams } from "@angular/common/http"
import BrandGetRequest from "../models/brand/brand-get-request"
import { toHttpParams } from "src/app/core/helpers/http-params-extensions"

@Injectable()
export class BrandService {
  private post_brand_url: string
  private put_brand_url: string
  private get_brand_id: string
  private get_brand_url: string

  private buildUrls(brandUrl: string) {
    this.post_brand_url =
      brandUrl + environment.endpointProduct.routes.post_brand
    this.get_brand_id =
      brandUrl + environment.endpointProduct.routes.get_brand_id
    this.get_brand_url = brandUrl + environment.endpointProduct.routes.get_brand
    this.put_brand_url = brandUrl + environment.endpointProduct.routes.put_brand
  }

  constructor(private httpClient: HttpClient, private appService: AppService) {
    this.buildUrls(environment.endpointProduct.url)
  }

  postBrand(brand: Brand) {
    return this.httpClient.post(this.post_brand_url, brand)
  }

  putBrand(brand: Brand) {
    return this.httpClient.put(
      this.put_brand_url.replace("{brandId}", brand.ID),
      brand
    )
  }

  getAllBrand(brand: BrandGetRequest) {
    const params = toHttpParams(brand)

    return this.httpClient.get(this.get_brand_url, { params })
  }

  getOne(brandId: string) {
    return this.httpClient.get(this.get_brand_id.replace("{brandId}", brandId))
  }
}
